const UNDEFINED_ERROR = 'UNDEFINED_ERROR';
export function undefinedError() {
  return {
    type: UNDEFINED_ERROR
  };
}

export default UNDEFINED_ERROR;
